import { useContext } from "react";
import { DrawerContext } from "../DrawerContext";

const useDrawer = () => {
  const context = useContext(DrawerContext);

  if (context === undefined) {
    throw new Error("DrawerContext is not initialized.");
  }

  return context;
};

export { useDrawer };
